import { NumericalMenuOption } from './types';

export const optionsForDays: NumericalMenuOption[] = [
  {
    text: '2 days',
    value: 2,
  },
  {
    text: '7 days',
    value: 7,
  },
  {
    text: '14 days',
    value: 14,
  },
  {
    text: '28 days',
    value: 28,
  },
  {
    text: '60 days',
    value: 60,
  },
  {
    text: '90 days',
    value: 90,
  },
  {
    text: '180 days',
    value: 180,
  },
  {
    text: '365 days',
    value: 365,
  },
];
